const DEFAULT_COLOR = '3, 129, 143';
const DEFAULT_INTERACTIVE_COLOR = '249, 110, 71';

export {
  DEFAULT_COLOR,
  DEFAULT_INTERACTIVE_COLOR,
};
